/* HENA.AX — chispas de Halloween con el mouse (solo si el visitante usa mouse y no pidió menos movimiento) */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var colores = ['#ff6a13', '#ff8a3d', '#ffb27a'];
  var ultimo = 0, vivas = 0;
  document.addEventListener('mousemove', function (e) {
    var t = Date.now();
    if (t - ultimo < 45 || vivas > 16) return;
    ultimo = t; vivas++;
    var s = document.createElement('span');
    var tam = 3 + Math.random() * 4, c = colores[Math.floor(Math.random() * colores.length)];
    s.setAttribute('aria-hidden', 'true');
    s.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;border-radius:50%;left:' + (e.clientX - tam / 2) + 'px;top:' + (e.clientY - tam / 2) + 'px;width:' + tam + 'px;height:' + tam + 'px;background:' + c + ';box-shadow:0 0 10px ' + c + ';';
    document.body.appendChild(s);
    var dx = (Math.random() - 0.5) * 28, dy = -(18 + Math.random() * 34);
    var a = s.animate([{ transform: 'translate(0,0) scale(1)', opacity: 0.95 }, { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.2)', opacity: 0 }], { duration: 750 + Math.random() * 350, easing: 'ease-out' });
    a.onfinish = function () { s.remove(); vivas--; };
  }, { passive: true });
})();
